import { gql } from '@apollo/client';

export default gql`
  mutation updateProfilePassword($password: String!) {
    updateProfilePassword(password: $password)
  }
`;
